import { deleteView, saveView } from './actions';
import {
  OPEN_VIEW_DRAWER,
  CLOSE_VIEW_DRAWER,
  SET_CURRENT_VIEW,
  SET_DEFAULT_VIEW,
  SET_DEFAULT_VIEW_START,
  SET_DEFAULT_VIEW_FAILURE,
  OPEN_VIEW_DIALOG,
  CLOSE_VIEW_DIALOG,
  SET_DIALOG_TYPE,
  SET_DIALOG_SUBTYPE,
  SAVE_VIEW_START,
  SAVE_VIEW_SUCCESS,
  SAVE_VIEW_FAILURE,
  DELETE_VIEW_START,
  DELETE_VIEW_SUCCESS,
  DELETE_VIEW_FAILURE,
  RENAME_VIEW_START,
  RENAME_VIEW_SUCCESS,
  RENAME_VIEW_FAILURE,
  FETCH_VIEWS_START,
  FETCH_VIEWS_SUCCESS,
  FETCH_VIEWS_FAILURE,
  EDIT_VIEW_START,
  EDIT_VIEW_SUCCESS,
  EDIT_VIEW_FAILURE,
  CLEAR_VIEW_MANAGEMENT_ALERTS,
  SET_SELECTED_VIEW_FOR_EDIT,
  SET_SELECTED_VIEWS,
  CLEAR_SELECTED_VIEWS,
  SET_SITE_LIST,
  SET_NO_ACCESS_SITE_LIST,
  SET_COST_CENTER_LIST,
  SET_QUICK_LINK_CONTACTS_LIST,
  CLEAR_ALL_LISTS,
  FETCH_PRIMARY_LIST_DATA_START,
  FETCH_PRIMARY_LIST_DATA_SUCCESS,
  FETCH_PRIMARY_LIST_DATA_FAILURE,
  SET_FILTERED_SITE_LIST,
  SET_FILTERED_COST_CENTER_LIST,
  CLEAR_ALL_FILTERED_LISTS,
  SET_DEFAULT_FILTERED_SITE_LIST,
  SET_DEFAULT_FILTERED_COST_CENTER_LIST,
  CLEAR_ALL_DEFAULT_FILTERED_LISTS,
  SET_VIEW_AND_USER_CONFIG_READY,
} from './constants';

const initialState = {
  // Drawer state
  isDrawerOpen: false,
  currentView: null,
  defaultView: null,

  saveViewCount: 0,
  
  // Dialog state
  isDialogOpen: false,
  dialogType: null,
  dialogSubtype: null,
  dialogData: null,
  
  // Views data
  views: [],
  viewsInfo: null, // Complete fetch view response data
  selectedViewForEdit: null,
  selectedViews: [],
  
  // List data
  siteList: [],
  noAccessSiteList: [],
  costCenterList: [],
  quickLinkContactsList: [],
  
  // Filtered list data by views
  filteredSiteListByViews: {},
  filteredCostCenterListByViews: {},
  
  // Default filtered list data by views (API provided data)
  defaultFilteredSiteListByViews: {},
  defaultFilteredCostCenterListByViews: {},
  
  // Loading states
  loading: false,
  saveLoading: false,
  deleteLoading: false,
  renameLoading: false,
  editLoading: false,
  selectLoading: false,
  setDefaultLoading: false,
  primaryListDataLoading: false,
  updateCurrentViewTimestamp: null,
  defaultViewUpdateCount: 0,
  deleteViewCount: 0,
  
  // Error state
  error: null,
  
  // Alerts
  alerts: [],
  isViewAndUserConfigReady: false,
};

const viewManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    // Drawer actions
    case OPEN_VIEW_DRAWER:
      return {
        ...state,
        isDrawerOpen: true
      };

    case CLOSE_VIEW_DRAWER:
      return {
        ...state,
        isDrawerOpen: false,
        isDialogOpen: false,
        dialogType: null,
        dialogSubtype: null,
        dialogData: null
      };

    case SET_CURRENT_VIEW:
      return {
        ...state,
        currentView: action.payload,
        updateCurrentViewTimestamp: Date.now()
      };

    case SET_DEFAULT_VIEW:
      return {
        ...state,
        defaultView: action.payload,
        setDefaultLoading: false,
        error: null,
        defaultViewTimestamp: Date.now(),
        defaultViewUpdateCount: (state.defaultViewUpdateCount || 0) + 1
      };

    case SET_DEFAULT_VIEW_START:
      return {
        ...state,
        setDefaultLoading: true,
        error: null,
      };

    case SET_DEFAULT_VIEW_FAILURE:
      return {
        ...state,
        setDefaultLoading: false,
        error: action.payload,
      };

    // Dialog actions
    case OPEN_VIEW_DIALOG:
      return {
        ...state,
        isDialogOpen: true,
        dialogType: action.payload.dialogType,
        dialogSubtype: action.payload.dialogSubtype || null,
        dialogData: action.payload.data
      };

    case CLOSE_VIEW_DIALOG:
      return {
        ...state,
        isDialogOpen: false,
        dialogType: null,
        dialogSubtype: null,
        dialogData: null
      };

    case SET_DIALOG_TYPE:
      return {
        ...state,
        dialogType: action.payload
      };

    case SET_DIALOG_SUBTYPE:
      return {
        ...state,
        dialogSubtype: action.payload
      };

    // Save view actions
    case SAVE_VIEW_START:
      return {
        ...state,
        saveLoading: true,
        error: null
      };

    case SAVE_VIEW_SUCCESS:
      return {
        ...state,
        saveLoading: false,
        saveViewCount: (state.saveViewCount || 0) + 1
        // views: [...state.views, action.payload],
        // currentView: action.payload.name
      };

    case SAVE_VIEW_FAILURE:
      return {
        ...state,
        saveLoading: false,
        error: action.payload
      };

    // Delete view actions
    case DELETE_VIEW_START:
      return {
        ...state,
        deleteLoading: true,
        error: null
      };

    case DELETE_VIEW_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteViewCount: (state.deleteViewCount || 0) + 1
      };

    case DELETE_VIEW_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        error: action.payload
      };

    // Rename view actions
    case RENAME_VIEW_START:
      return {
        ...state,
        renameLoading: true,
        error: null
      };

    case RENAME_VIEW_SUCCESS:
      return {
        ...state,
        renameLoading: false,
        saveViewCount: (state.saveViewCount || 0) + 1
      };

    case RENAME_VIEW_FAILURE:
      return {
        ...state,
        renameLoading: false,
        error: action.payload
      };

   // Fetch views actions
    case FETCH_VIEWS_START:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_VIEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        views: action.payload?.filterSelections?.metadata?.allViewList || [],
        viewsInfo: action.payload
      };

    case FETCH_VIEWS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_PRIMARY_LIST_DATA_START:
      return {
        ...state,
        primaryListDataLoading: true,
      };

    case FETCH_PRIMARY_LIST_DATA_SUCCESS:
      return {
        ...state,
        primaryListDataLoading: false,
      };

    case FETCH_PRIMARY_LIST_DATA_FAILURE:
      return {
        ...state,
        primaryListDataLoading: false,
        error: action.payload,
      };

    // Clear alerts
    case CLEAR_VIEW_MANAGEMENT_ALERTS:
      return {
        ...state,
        error: null,
        alerts: []
      };

    // Edit view actions
    case EDIT_VIEW_START:
      return {
        ...state,
        selectLoading: true,
        error: null
      };
    
    case EDIT_VIEW_SUCCESS:
      return {
        ...state,
        selectLoading: false,
        currentView: action.payload.viewName || action.payload.name,
        isDialogOpen: false,
        dialogType: null,
        error: null
      };
    
    case EDIT_VIEW_FAILURE:
      return {
        ...state,
        selectLoading: false,
        error: action.payload.messageCode || action.payload.message || 'Failed to apply view'
      };
    
    // Selection actions
    case SET_SELECTED_VIEW_FOR_EDIT:
      return {
        ...state,
        selectedViewForEdit: action.payload
      };
    
    case SET_SELECTED_VIEWS:
      return {
        ...state,
        selectedViews: action.payload
      };
    
    case CLEAR_SELECTED_VIEWS:
      return {
        ...state,
        selectedViews: [],
        selectedViewForEdit: null
      };

    // List management actions
    case SET_SITE_LIST:
      return {
        ...state,
        siteList: action.payload
      };

    case SET_NO_ACCESS_SITE_LIST:
      return {
        ...state,
        noAccessSiteList: action.payload
      };

    case SET_COST_CENTER_LIST:
      return {
        ...state,
        costCenterList: action.payload
      };

    case SET_QUICK_LINK_CONTACTS_LIST:
      return {
        ...state,
        quickLinkContactsList: action.payload
      };

    case CLEAR_ALL_LISTS:
      return {
        ...state,
        siteList: [],
        noAccessSiteList: [],
        costCenterList: [],
        quickLinkContactsList: []
      };

    // Filtered list management actions
    case SET_FILTERED_SITE_LIST:
      return {
        ...state,
        filteredSiteListByViews: {
          ...state.filteredSiteListByViews,
          [action.payload.viewName]: action.payload.data
        }
      };

    case SET_FILTERED_COST_CENTER_LIST:
      return {
        ...state,
        filteredCostCenterListByViews: {
          ...state.filteredCostCenterListByViews,
          [action.payload.viewName]: action.payload.data
        }
      };

    case CLEAR_ALL_FILTERED_LISTS:
      return {
        ...state,
        filteredSiteListByViews: {},
        filteredCostCenterListByViews: {},
        defaultFilteredSiteListByViews: {},
        defaultFilteredCostCenterListByViews: {}
      };

    // Default filtered list management actions
    case SET_DEFAULT_FILTERED_SITE_LIST:
      return {
        ...state,
        defaultFilteredSiteListByViews: {
          ...state.defaultFilteredSiteListByViews,
          [action.payload.viewName]: action.payload.data
        }
      };

    case SET_DEFAULT_FILTERED_COST_CENTER_LIST:
      return {
        ...state,
        defaultFilteredCostCenterListByViews: {
          ...state.defaultFilteredCostCenterListByViews,
          [action.payload.viewName]: action.payload.data
        }
      };

    case CLEAR_ALL_DEFAULT_FILTERED_LISTS:
      return {
        ...state,
        defaultFilteredSiteListByViews: {},
        defaultFilteredCostCenterListByViews: {}
      };

    case SET_VIEW_AND_USER_CONFIG_READY:
      return {
        ...state,
        isViewAndUserConfigReady: !!action.payload,
      };



    default:
      return state;
  }
};

export default viewManagementReducer;